
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200.27 186"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 0h200.27v186H0z"}})]),_c('clipPath',{attrs:{"id":"clip-path-2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M200.27 414.31H0v-186h200.27z"}})]),_c('clipPath',{attrs:{"id":"clip-path-3"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 520h1920v1080H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path)","id":"oneTimeInspiration4"}},[_c('path',{attrs:{"fill":"#00213d","d":"M0 0h200.27v186H0z"}}),_c('path',{attrs:{"id":"transformEl2","d":"M-14.34 53.77C8.1 62.6 37.24 76.53 61.53 97.1c33.34 28.24 40.32 54.43 43.38 66.87a96.21 96.21 0 01-1.65 52H-18.19V52.11l1.36.55c.89.34 1.72.75 2.49 1.11z","fill":"#0092ff"}}),_c('ellipse',{attrs:{"id":"transformEl","cx":"156.85","cy":"17.21","rx":"67.73","ry":"77.38","fill":"#00317f"}})])])
          )
        }
      }
    